export const environment = {
    REACT_APP_MOD: process.env.REACT_APP_MOD  ,
    isDevelopment : process.env.REACT_APP_MOD == 'development',
    localRestUrl : 'http://rest.onro.org'
}
